export const HONEYPOT_FIELD = "company_alt";

export type SubmitResult = { ok: boolean; message: string };

export async function submitReaddyForm(
  form: HTMLFormElement,
  submitAddr: string
): Promise<SubmitResult> {
  const formData = new FormData(form);
  formData.delete(HONEYPOT_FIELD);

  const params = new URLSearchParams();
  formData.forEach((value, key) => {
    if (typeof value === "string") {
      params.append(key, value);
    }
  });

  try {
    const res = await fetch(submitAddr, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: params.toString(),
    });
    const responseText = await res.text();
    let parsed: {
      code?: string;
      message?: string;
      meta?: { message?: string; detail?: string };
    } | null = null;
    try {
      parsed = JSON.parse(responseText);
    } catch {
      parsed = null;
    }
    const serverMsg =
      parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
    if (res.ok && parsed?.code === "OK") {
      return { ok: true, message: "" };
    }
    return { ok: false, message: serverMsg };
  } catch {
    return { ok: false, message: "" };
  }
}

export function validateForm(
  formData: FormData,
  requiredFields: string[],
  emailField?: string
): Record<string, string> {
  const errors: Record<string, string> = {};
  requiredFields.forEach((key) => {
    const value = (formData.get(key) as string)?.trim() || "";
    if (!value) errors[key] = "請完成此欄位。";
  });
  if (emailField) {
    const email = (formData.get(emailField) as string)?.trim() || "";
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors[emailField] = "請輸入有效的 Email。";
    }
  }
  return errors;
}